var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "li",
    { staticClass: "item", class: { "active-drop": _vm.active } },
    [
      _vm.item.sublinks.length > 0
        ? _c(
            "div",
            { staticClass: "menu-item", on: { click: _vm.click } },
            [
              _c("span", [
                _vm._v(_vm._s(_vm.item.title) + "\n      "),
                _c(
                  "svg",
                  {
                    attrs: {
                      width: "11px",
                      height: "6px",
                      viewBox: "0 0 11 6",
                      version: "1.1",
                      xmlns: "http://www.w3.org/2000/svg",
                      "xmlns:xlink": "http://www.w3.org/1999/xlink"
                    }
                  },
                  [
                    _c(
                      "g",
                      {
                        attrs: {
                          id: "Navigation",
                          stroke: "none",
                          "stroke-width": "1",
                          fill: "none",
                          "fill-rule": "evenodd",
                          opacity: "0.699999988"
                        }
                      },
                      [
                        _c(
                          "g",
                          {
                            attrs: {
                              id: "klassik-joined-navi-v2",
                              transform: "translate(-1310.000000, -21.000000)",
                              stroke: "currentColor",
                              "stroke-width": "1.5"
                            }
                          },
                          [
                            _c(
                              "g",
                              {
                                attrs: {
                                  id: "UI/dropdown_arrow",
                                  transform: "translate(1311.000000, 22.000000)"
                                }
                              },
                              [
                                _c("polyline", {
                                  attrs: {
                                    id: "Path-2",
                                    points:
                                      "0.375 0.204212135 4.49758538 3.8 8.625 0.2"
                                  }
                                })
                              ]
                            )
                          ]
                        )
                      ]
                    )
                  ]
                )
              ]),
              _vm._v(" "),
              _c("transition", { attrs: { name: "smooth" } }, [
                _vm.item.sublinks.length > 0 && _vm.active
                  ? _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "on-clickaway",
                            rawName: "v-on-clickaway",
                            value: _vm.away,
                            expression: "away"
                          }
                        ],
                        staticClass: "dropdown",
                        class: _vm.grid(_vm.item.sublinks.length)
                      },
                      _vm._l(_vm.activeItem.sublinks, function(subItem, index) {
                        return _c("subitem", {
                          key: index,
                          attrs: { subitem: subItem }
                        })
                      }),
                      1
                    )
                  : _vm._e()
              ])
            ],
            1
          )
        : _c("a", { staticClass: "menu-item", attrs: { href: _vm.item.url } }, [
            _vm._v(_vm._s(_vm.item.title))
          ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }